import { SourceProduct } from "../services/bff/coordinator/dto/Contracts.dto";

export class SourceProductHelper {
    static isInterestPaidByRetailer(sourceProduct?: string): boolean {
        return sourceProduct === SourceProduct.INTEREST_PAID_BY_RETAILER
    }
}